module.exports = __webpack_public_path__ + "media/images/office-1-5fcb8af5.jpg";